import {Card} from 'platform/components';
import {Grid, Text, VStack} from 'platform/foundation';

import {Fragment} from 'react';

import i18n from '@dms/i18n';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {AbcXyzThreshold} from '../types/AbcXyzThreshold';

const COLUMN_COUNT = 3;

interface AbcXyzThresholdsTableProps extends RequiredTestIdProps {
  title: string;
  thresholds: AbcXyzThreshold[];
}

export function AbcXyzThresholdsTable(props: AbcXyzThresholdsTableProps) {
  return (
    <Card isFullHeight data-testid={props['data-testid']}>
      <VStack spacing={2}>
        <Text size="small" alternative>
          {props.title}
        </Text>
        <Grid columns={COLUMN_COUNT} spacing={1}>
          <Text size="xSmall" color="secondary">
            {i18n.t('entity.warehouse.reporting.thresholdClass')}
          </Text>
          <Text size="xSmall" color="secondary">
            {i18n.t('entity.warehouse.reporting.thresholdRange')}
          </Text>
          <Text size="xSmall" color="secondary">
            {i18n.t('entity.warehouse.reporting.thresholdDescription')}
          </Text>
          {props.thresholds.map((threshold) => (
            <Fragment key={threshold.id}>
              <Text
                size="small"
                alternative
                data-testid={suffixTestId(`${threshold.id}-class`, props)}
              >
                {threshold.className}
              </Text>
              <Text size="small" data-testid={suffixTestId(`${threshold.id}-range`, props)}>
                {threshold.range}
              </Text>
              <Text size="small" data-testid={suffixTestId(`${threshold.id}-description`, props)}>
                {threshold.description}
              </Text>
            </Fragment>
          ))}
        </Grid>
      </VStack>
    </Card>
  );
}
